import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "@univerjs/design/lib/index.css";
import "@univerjs/ui/lib/index.css";
import "@univerjs/sheets-ui/lib/index.css";
import "@univerjs/docs-ui/lib/index.css";
import "@univerjs/preset-sheets-core/lib/index.css";
import "@univerjs/preset-docs-core/lib/index.css";
import RoutesControl from "./router";
import React from "react";
import { ToastContainer } from "react-toastify";
import { GoCheck } from "react-icons/go";
import { RxCross2 } from "react-icons/rx";

//https://theme-builder.netlify.app/
//https://github.com/atapas/theme-builder
//https://blog.logrocket.com/complete-guide-authentication-with-react-router-v6/

function App() {
  return (
    <>
      <ToastContainer
        position="bottom-left"
        autoClose={700}
        pauseOnHover
        theme="colored"
        limit={1}
        icon={({ type }) => {
          switch (type) {
            case "error":
              return <RxCross2 />;
            case "success":
              return <GoCheck />;
            default:
              return "ℹ️";
          }
        }}
      />
      <div className="App" data-theme="default">
        <RoutesControl />
      </div>
    </>
  );
}

export default App;
